export default "<ion-app>\r\n\r\n  <ion-router-outlet></ion-router-outlet>\r\n\r\n</ion-app>\r\n";